import { store } from 'redux/store';
import { State } from 'redux/initialState';
import { useHistory } from 'react-router-dom';
import { FC, ReactNode, createContext, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setModal } from 'modules/_shared/redux/modalActions';
import { getTenderOffers } from 'modules/transactions/redux/tenderOfferActions';

import { BeneficiaryTenderOfferSelectorModalContextType } from '../types/BeneficiaryTenderOfferSelectorModalContextType';
import { beneficiaryTenderOfferSelectorModalInitValue } from '../constants/beneficiaryTenderOfferSelectorModalInitValue';
import { useGetTenderOfferOptions } from '../hooks/useTenderOfferOptions';

type BeneficiaryTenderOfferSelectorModalContextProps = {
  children: ReactNode;
  beneficiaryId: string;
};

const BeneficiaryTenderOfferSelectorModalContext =
  createContext<BeneficiaryTenderOfferSelectorModalContextType>(
    beneficiaryTenderOfferSelectorModalInitValue
  );

export const BeneficiaryTenderOfferSelectorModalProvider: FC<
  BeneficiaryTenderOfferSelectorModalContextProps
> = ({ children, beneficiaryId }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const actualSociety = useSelector(
    (state: State) => state.society?.actualSociety
  );
  const tenderOffers = useSelector((state: State) => state.tenderOffers);

  const { data: tenderOfferOptionsData, actions: tenderOfferOptionsActions } =
    useGetTenderOfferOptions({
      beneficiaryId,
      tenderOffers,
    });

  useEffect(() => {
    if (!actualSociety) return;
    store.dispatch(getTenderOffers(actualSociety._id));
  }, [actualSociety]);

  const handleCloseModal = () => {
    dispatch(setModal(null));
  };

  const handleSeeTenderOffer = async () => {
    history.push(
      `/participacion-tender-offer/${actualSociety?._id}/${tenderOfferOptionsData.selectedTenderOffer}/beneficiario/${beneficiaryId}`
    );
    handleCloseModal();
  };

  return (
    <BeneficiaryTenderOfferSelectorModalContext.Provider
      value={{
        data: {
          selectedTenderOfferOption:
            tenderOfferOptionsData.selectedTenderOfferOption,
          tenderOfferOptions: tenderOfferOptionsData.tenderOfferOptions,
        },
        actions: {
          handleCloseModal,
          handleChangeTenderOfferOption:
            tenderOfferOptionsActions.handleChangeTenderOfferOption,
          handleSeeTenderOffer,
        },
      }}
    >
      {children}
    </BeneficiaryTenderOfferSelectorModalContext.Provider>
  );
};

export const useBeneficiaryTenderOfferSelectorModal = () => {
  const context = useContext(BeneficiaryTenderOfferSelectorModalContext);
  if (!context) {
    throw new Error(
      'useBeneficiaryTenderOfferSelectorModal must be used within a BeneficiaryTenderOfferSelectorModalProvider'
    );
  }
  return context;
};
